import { Search } from "lucide-react";
import { Input } from "@/shared/components";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { GlobalSearchDialog } from "@/shared/components";
import { Badge } from "@/shared/ui/badge";
import { useUserScopeStore } from "@/features/auth/model/user-scope.store";

export const CentralSearch = () => {
  const { t } = useTranslation('common');
  const [open, setOpen] = useState(false);
  const isDemo = useUserScopeStore((s) => s.scope?.account?.isDemo === true);

  // Keyboard shortcut
  useEffect(() => {
    const down = (e: KeyboardEvent) => {
      if (e.key === "k" && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        setOpen(true);
      }
    };

    document.addEventListener("keydown", down);
    return () => document.removeEventListener("keydown", down);
  }, []);

  return (
    <>
      <div className="flex-1 max-w-md">
        <div className="flex items-center gap-2">
          <div className="relative flex-1 cursor-pointer" onClick={() => setOpen(true)}>
            <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
            <Input
              type="search"
              placeholder={t('search.shortcut')}
              className="pl-10 cursor-pointer"
              readOnly
            />
            <kbd className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none hidden sm:inline-flex h-5 select-none items-center gap-1 rounded border bg-muted px-1.5 font-mono text-[10px] font-medium text-muted-foreground">
              <span className="text-xs">⌘</span>K
            </kbd>
          </div>

          {isDemo && (
            <Badge
              variant="orange"
              title={t('demo.modeActiveTooltip')}
              aria-label={t('demo.modeActiveTooltip')}
              className="shrink-0"
            >
              {t('demo.modeActiveBadge')}
            </Badge>
          )}
        </div>
      </div>

      <GlobalSearchDialog open={open} onOpenChange={setOpen} />
    </>
  );
};
